import { motion, useReducedMotion } from 'framer-motion'
import SealEmblem from './SealEmblem'
function CardSealBadge() {
  const reduceMotion = useReducedMotion()
  return (
    <motion.span
      role="img"
      aria-label="Verified on Polygon"
      className="flex h-[80px] w-[80px] items-center justify-center rounded-full bg-black/60 ring-1 ring-white/20 backdrop-blur-sm"
      style={{ boxShadow: '0 14px 26px rgba(0,0,0,0.55), 0 3px 8px rgba(0,0,0,0.4)' }}
      animate={reduceMotion ? void 0 : { y: [0, -3, 0] }}
      transition={{ duration: 3.2, repeat: Infinity, ease: 'easeInOut' }}
    >
      <SealEmblem ready className="h-[68px] w-[68px]" />
    </motion.span>
  )
}
export { CardSealBadge as default }
